import { useListItem } from '@floating-ui/react'
import clsx from 'clsx'
import { ReactNode } from 'react'
import { useComboboxContext } from './ComboboxContext'
import styles from './ComboboxOption.module.scss'
import { Checkbox } from '../Checkbox'

export interface ComboboxOptionProps {
  id: string
  children: ReactNode
  icon?: ReactNode
}

export const ComboboxOption = ({ children, id, icon, ...props }: ComboboxOptionProps) => {
  const { activeIndex, selectedIndexes, getItemProps, handleSelect, size, allowMultiple } =
    useComboboxContext()
  const { ref, index } = useListItem({ label: id })

  const isActive = activeIndex === index
  const isSelected = selectedIndexes.includes(index)

  return (
    <li
      ref={ref}
      role="option"
      aria-selected={isSelected}
      tabIndex={isActive ? 0 : -1}
      className={clsx(styles.option, styles[size], {
        [styles.active]: isActive,
        [styles.selected]: isSelected,
        [styles.selected]: isSelected,
      })}
      {...getItemProps?.({
        onClick: () => handleSelect(index),
      })}
      {...props}
    >
      {allowMultiple && (
        <Checkbox
          id={id}
          label={''}
          size="sm"
          checked={isSelected}
          onChange={() => handleSelect(index)}
          className={styles.checkbox}
        />
      )}
      <div className={styles.inner}>
        {icon}
        <div className={clsx(styles.children)}>{children}</div>
      </div>
    </li>
  )
}
